// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackViewItemListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackViewItemList";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackViewItemList = (
    parameters: PartialSpecific<TrackViewItemListParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackViewItemListParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        promotions: ga.use.promotions(options),
        cart: ga.use.cart(options),
        order: ga.use.order(options),
        invoice: ga.use.invoice(options),
        quote: ga.use.quote(options),
        wishList: ga.use.wishList(options),
        ...options,
    };

    return (parameters: Partial<TrackViewItemListParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.viewItemList({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackViewItemList;
